module.exports = _.startsWith;